import { Component, Fragment } from 'react';
import styles from '../../styles/home/carousalCard.scss';
import { Router } from '../../configs/routes';
import cx from 'classnames';
import Button from '../ui/button';
import { handleTrack } from '../../utils/trackActions';

interface Props {
  title?: string;
  subtitle?: string;
  isImportant?: boolean;
  ctaLink?: any;
  ctaLabel?: string;
  ctaClassName?: string;
  dashboardData?: any;
  icon?: string;
}

class CarousalCard extends Component<Props, any> {
  public completePendingAction = () => {
    const { title, ctaLabel, ctaLink } = this.props;
    const path = `/save/${ctaLink}`;
    handleTrack({
      label: `pending_action_view_${title}_${ctaLabel}`,
      url: path,
    });
    Router.pushRoute(path);
  };

  public render() {
    const { title, subtitle, isImportant, ctaLabel } = this.props;
    return (
      <Fragment>
        {isImportant ? (
          <div
            className={cx('left', styles['pending-action'])}
            onClick={this.completePendingAction}
          >
            <span
              className={cx(
                styles['title'],
                'text--xlg float--left mb10 mobile-only--mb0'
              )}
            >
              {title}
            </span>
            <span
              className={cx(
                styles['important-item'],
                'text--xsm  float--right'
              )}
            >
              Important
            </span>
            <div
              className={cx(
                styles['sub-title'],
                'text--md small-11 inline-block mb10'
              )}
            >
              {subtitle}
            </div>
            <Button
              className={cx(
                's-btn s-btn--white s-btn--card-button btn-caps btn-shine text--sm float--right',
                styles['action-btn']
              )}
              label={ctaLabel}
            />
          </div>
        ) : null}
      </Fragment>
    );
  }
}

export default CarousalCard;



// WEBPACK FOOTER //
// ./components/home/carousalCard.tsx